import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

import styles from './styles.scss';

function DropdownSelect({
  options,
  isMulti,
  onChange,
  ariaLabel,
  name,
  className,
  ...otherProps
}) {
  return (
    <ReactSelect
      className={`${styles.reactSelectContainer} ${className}`}
      classNamePrefix="react-select"
      options={options}
      isMulti={isMulti}
      onChange={onChange}
      aria-label={ariaLabel}
      name={name}
      {...otherProps}
    />
  );
}

DropdownSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string
    })
  ).isRequired,
  isMulti: PropTypes.bool,
  onChange: PropTypes.func,
  ariaLabel: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string
};

DropdownSelect.defaultProps = {
  ariaLabel: 'Select',
  isMulti: false,
  name: '',
  onChange: () => {},
  className: ''
};

export default DropdownSelect;
